var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgElectricCabin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_544",
    "data-name": "Path 544",
    d: "M1114.507,412.409a4.109,4.109,0,0,0-3.02-1.26h-37.45a4.117,4.117,0,0,0-2.98,1.26,4.062,4.062,0,0,0-1.29,3.02v37.45a4.393,4.393,0,0,0,4.27,4.27h37.45a4.09,4.09,0,0,0,3.02-1.28,4.156,4.156,0,0,0,1.26-2.99v-37.45a4.109,4.109,0,0,0-1.26-3.02m-10.73,22.43-14.89,13.35a1,1,0,0,1-.77.3,1.108,1.108,0,0,1-.77-.33,1.261,1.261,0,0,1-.31-.74.949.949,0,0,1,.21-.73l6.95-9.72-11.64-1.12a1.307,1.307,0,0,1-1.22-.96,1.286,1.286,0,0,1,.42-1.52l14.89-13.35a1,1,0,0,1,.77-.3,1.108,1.108,0,0,1,.77.33,1.261,1.261,0,0,1,.31.74.948.948,0,0,1-.21.73l-6.95,9.72,11.64,1.12a1.306,1.306,0,0,1,1.22.96,1.286,1.286,0,0,1-.42,1.52",
    transform: "translate(-1069.767 -411.149)",
    fill: "var(--primary-color)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgElectricCabin);
export default __webpack_public_path__ + "static/media/electricCabin.527b2153f7915cb14e4be116f611abdc.svg";
export { ForwardRef as ReactComponent };